import { useEffect } from 'react';
import { useKiosk } from '../hooks/useKiosk';

export const KioskBodyClass = () => {
  const { isKioskMode } = useKiosk();

  useEffect(() => {
    if (isKioskMode) {
      document.body.classList.add('kiosk-mode');
    } else {
      document.body.classList.remove('kiosk-mode');
    }
  }, [isKioskMode]);

  return null; // No renderiza nada en el DOM
};

